import {useOutlet, Outlet} from 'react-router-dom';

const Nyi = _ => {
    const outlet = useOutlet();

    return outlet != null ? <Outlet /> : <div>
        <img src="/nyi.png" alt="page is under construction" className="w-100" />
    </div>
}

export default Nyi;